// extracted by mini-css-extract-plugin
export default {"container":"UserInstructionsSection_container__ZryNj","main_title":"UserInstructionsSection_main_title__vyLDN","sub_title":"UserInstructionsSection_sub_title__xjlCK"};